<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #dcfce7; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">check_circle</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Marcar como pagada</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Confirmar transferencia enviada</p>
    </div>
  </div>

  <!-- Info card -->
  <div style="margin: 16px 24px; padding: 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID Transacción</span>
        <span style="color: #2563eb; font-weight: 700; font-size: 0.9rem; font-family: monospace;">#{{ transaction?.id }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario</span>
        <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ transaction?.nombreUsuario }} {{ transaction?.apellidosUsuario }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Email</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction?.emailUsuario }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">RUT</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ transaction?.numeroId }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction?.bancoNombre }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Cuenta</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ transaction?.tipoCuentaNombre }} {{ transaction?.numeroCuenta }}</span>
      </div>
      <div style="grid-column: 1 / -1; padding-top: 4px; border-top: 1px solid #bbf7d0;">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto</span>
        <span style="color: #1e5a3f; font-weight: 700; font-size: 1.1rem;">
          {{ transaction?.totalMonedaDestino | currency:'':'':'' }} {{ transaction?.monedaDestino }}
        </span>
      </div>
    </div>
  </div>

  <!-- Form -->
  <div style="padding: 0 24px;" *ngIf="datosForm">
    <form [formGroup]="datosForm">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Referencia</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">receipt</mat-icon>
        <input matInput formControlName="referencia" placeholder="Opcional">
      </mat-form-field>
    </form>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button (click)="acceptTransaction()" [disabled]="datosForm?.invalid"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      [style.opacity]="datosForm?.invalid ? '0.5' : '1'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">check</mat-icon>
      Marcar como pagada
    </button>
  </div>

</div>
